import { initializeApp } from 'firebase/app';
import { getAnalytics, isSupported } from 'firebase/analytics';
import { getAuth, connectAuthEmulator } from 'firebase/auth';

const firebaseConfigs = {
  emulator: {apiKey: 'demo-centerfire-mobile', projectId: 'demo-centerfire-mobile', authDomain: 'localhost'},
  development: {
    apiKey: 'AIzaSyBJi_QDxxG47g3bk6sTkSSt96ANOTw0b1o',
    authDomain: 'centerfiretx-dev.firebaseapp.com',
    projectId: 'centerfiretx-dev',
    storageBucket: 'centerfiretx-dev.firebasestorage.app',
    messagingSenderId: '581755718686',
    appId: '1:581755718686:web:b2e26dc69e1815cbd5720f',
    measurementId: 'G-MW42MZVFXP',
  },
  production: {
    apiKey: 'AIzaSyBwkh2m-TyzA7zq6ipQ2q2ORQeBbP0tu00',
    authDomain: 'txcenterfire.firebaseapp.com',
    projectId: 'txcenterfire',
    storageBucket: 'txcenterfire.firebasestorage.app',
    messagingSenderId: '715087315261',
    appId: '1:715087315261:web:7ad46c0242a1ac7c8dc554',
    measurementId: 'G-TH80SMY1RV',
  },
};

// The dev server talks to the dev Firebase project. Production-mode builds are
// deliberately production by default; CI opts main into development explicitly.
const firebaseEnvironment = process.env.VUE_APP_FIREBASE_ENV ||
  (process.env.NODE_ENV === 'development' ? 'development' : 'production');
const firebaseConfig = firebaseConfigs[firebaseEnvironment];

if (!firebaseConfig) {
  throw new Error(`Unknown Firebase environment: ${firebaseEnvironment}`);
}

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
if (firebaseEnvironment === 'emulator') {
  if (process.env.NODE_ENV !== 'development') throw new Error('Emulator authentication is restricted to the local development server.');
  connectAuthEmulator(auth, process.env.VUE_APP_AUTH_EMULATOR_URL || 'http://127.0.0.1:9099');
}

if (typeof window !== 'undefined' && firebaseEnvironment !== 'emulator' && !window.location.pathname.startsWith('/sell/')) {
  isSupported().then((supported) => {
    if (supported) {
      getAnalytics(app);
    }
  }).catch(() => {
    // Analytics is optional; blocked cookies or browser APIs must not break the site.
  });
}

export default app;
export { auth, firebaseEnvironment };
